import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import GroupIcon from '@mui/icons-material/Group';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Page, Header } from 'components';
import Card from './components/Card/Card.js';
import UsersDataTable from './components/UsersDataTable/UsersDataTable.js';
import AddEditUsersDialog from './components/AddEditUserDialog/AddEditUserDialog.js';

import { GetUsers, GetUsersStats, ToggleAddEditUserDialog } from '../../actions/UsersActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const Users = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session.user);
	const usersStats = useSelector((state) => state.usersReducer.usersStats);
	const users = useSelector((state) => state.usersReducer.users);
	const openAddEditUserDialog = useSelector((state) => state.usersReducer.openAddEditUserDialog);

	const _addEditUserClose = () => {
		dispatch(ToggleAddEditUserDialog(false));
	};

	const _addUser = () => {
		dispatch(ToggleAddEditUserDialog(true));
	};

	const _renderActions = () => (
		<Button color="primary" variant="contained" onClick={_addUser}>
			<AddIcon />
			Add
		</Button>
	);

	const getData = useCallback(() => {
		dispatch(GetUsers(user.role));
		dispatch(GetUsersStats());
	}, []);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<Page className={classes.root} title="Users">
			<Header module="Management" view="Users" actions={_renderActions()} />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={3} sm={6} xs={12}>
					<Card title="online" text={usersStats.online} />
				</Grid>
				<Grid item lg={3} sm={6} xs={12}>
					<Card title="active" text={usersStats.active} icon={<GroupIcon />} />
				</Grid>
				<Grid item lg={3} sm={6} xs={12}>
					<Card title="client" text={usersStats.client} icon={<BusinessCenterIcon />} />
				</Grid>
				<Grid item lg={3} sm={6} xs={12}>
					<Card title="registered" text={usersStats.registered} icon={<AssignmentTurnedInIcon />} />
				</Grid>
				<Grid item lg={12} xs={12}>
					<UsersDataTable className={classes.results} data={users} user={user} />
				</Grid>
			</Grid>
			{openAddEditUserDialog && (
				<AddEditUsersDialog
					onClose={_addEditUserClose}
					open={openAddEditUserDialog}
					user={user}
				/>
			)}
		</Page>

	);
};

export default Users;
